// extracted by mini-css-extract-plugin
module.exports = {"formNumberTag":"FormNumberTag_formNumberTag__RM_nz"};